<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{this.lbl_loading}} ... </span>
</div>

<p-fieldset>

    <!-- <ng-template pTemplate="header">    </ng-template> -->
    <p-toolbar styleClass="p-mb-4">
        <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
            (click)="goBack()"></button>
    </p-toolbar>
    <div class="card">

        <p-table #dt [value]="lstData" [rows]="20" [paginator]="true" [globalFilterFields]="['supplId','name']"
            [(selection)]="selectedSupplier" [rowHover]="true" dataKey="supplId"
            styleClass="p-datatable-responsive-demo"
            currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
            [showCurrentPageReport]="true" editMode="row" responsiveLayout="scroll" responsive="true">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center p-jc-between">
                    <h5 class="p-m-0">{{this.lbl_vendor}} {{findOptInput}}</h5>
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                            placeholder="{{lbl_search}}..." />
                    </span>
                </div>

                <span class="p-input-icon-left">
                    <button type="button" pButton pRipple icon="pi pi-plus" (click)="newSupplier()" class="p-mr-4"
                        pTooltip="{{lbl_new_record}}" tooltipPosition="bottom"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                        class="p-button-success p-mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                        class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                </span>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="supplId">{{this.lbl_vendor}}<p-sortIcon field="supplId"></p-sortIcon></th>
                    <th pSortableColumn="name">{{this.lbl_name}}<p-sortIcon field="name"></p-sortIcon></th>
                    <th pSortableColumn="address">{{lbl_address}}<p-sortIcon field="address"></p-sortIcon></th>
                    <!-- <th pSortableColumn="shortName">short_Name_<p-sortIcon field="shortName"></p-sortIcon></th> -->
                    <th pSortableColumn="suppType">{{lbl_type}} {{lbl_vendor}}<p-sortIcon field="suppType"></p-sortIcon>
                    </th>
                    <th pSortableColumn="mobPhon">{{lbl_cell_phone}}<p-sortIcon field="mobPhon"></p-sortIcon></th>
                    <th pSortableColumn="email1">{{this.lbl_email}}<p-sortIcon field="email1"></p-sortIcon></th>
                    <!--  <th *ngIf="security && security.levelId=='I'" pSortableColumn="supplId">
                        {{this.lbl_vendor}}<p-sortIcon field="supplId"></p-sortIcon></th>  -->
                    <!--  <th pSortableColumn="language">Idioma<p-sortIcon field="language"></p-sortIcon></th> -->

                    <!-- <th *ngIf="security && security.levelId!='L'">{{this.lbl_edit}}</th> -->
                    <th>{{this.lbl_edit}}</th>
                    <!-- <th *ngIf="security && security.levelId=='I'">{{this.lbl_delete_record}}</th> -->
                    <th>{{this.lbl_delete_record}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <td>{{data.supplId}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.address}}</td>
                    <!-- <td>{{data.shortName}}</td> -->
                    <td>{{data.suppType}}</td>
                    <td>{{data.mobPhon}}</td>
                    <td>{{data.email1}}</td>
                    <!-- <td *ngIf="security && security.levelId=='I'">{{data.supplId}}</td>-->
                    <!-- <td>{{data.language != null ? data.language : ""}}</td> -->
                    <!-- <td>{{data.function}}</td> -->
                    <!-- <td>{{data.type}}</td> -->
                    <td>
                        <button type="button" pButton pRipple icon="pi pi-pencil"
                            class="p-button-rounded p-button-success mr-2" (click)="editSupplier(data)"></button>
                    </td>
                    <!--
                    <td *ngIf="security && security.levelId=='I'">
                    <button type="button" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteUsuario(data)"></button>
                    </td>
                    -->
                    <td>
                        <button type="button" pButton pRipple icon="pi pi-trash"
                            class="p-button-rounded p-button-warning" (click)="deleteSupplier(data)"></button>
                    </td>

                </tr>
            </ng-template>

            <ng-template pTemplate="summary">
                <div class="p-d-flex p-ai-center p-jc-between">
                    {{lbl_total}} {{lstData ? lstData.length : 0 }} {{lbl_records}}.
                </div>
            </ng-template>
        </p-table>


    </div>

    <!-- <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="Detalle Usuario" [modal]="true" styleClass="p-fluid" (onShow)="onShowModalOption()">   -->
    <p-dialog [(visible)]="optionDialog" [style]="{width: '550px'}" header="{{lbl_detail}} {{lbl_vendor}}"
        [modal]="true" styleClass="p-fluid">
        <ng-template pTemplate="content">

            <div class="field p-text-bold">
                <label for="opt">{{this.lbl_vendor}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwsupplId" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwsupplId">Se requiere nombre</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt">{{lbl_address}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwaddress" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwaddress">Se requiere nombre</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt">{{lbl_email}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwemail1" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwemail1">Se requiere email</small>
                <!-- <small class="p-error" *ngIf="submitted && !mailValid">Formato incorrecto Email</small> -->
            </div>

            <div class="field p-text-bold">
                <label for="opt">{{this.lbl_name}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwname" />
                <small class="p-error" *ngIf="submitted && !vwname">Se requiere nombre</small>
            </div>

            <!-- 
             <div class="field p-text-bold">
                <label for="opt">{{this.lbl_name}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwname" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwname">Se requiere nombre</small>
            </div>  
            -->
            <div class="field p-text-bold">
                <label for="opt">{{lbl_email}} {{lbl_send}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwsendEmail" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwsendEmail">Se requiere nombre</small>
            </div>
            <div class="field p-text-bold">
                <label for="opt">{{this.lbl_short_Name}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwshortName" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwshortName">Se requiere nombre</small>
            </div>
            <!-- 
             <div class="field p-text-bold">
                <label for="opt">status</label>
                <input type="text" pInputText id="name" [(ngModel)]="dataView.status" required autofocus />
                <small class="p-error" *ngIf="submitted && !dataView.status">Se requiere nombre</small>
            </div>  
            -->
            <div class="field p-text-bold">
                <label for="opt">{{this.lbl_storeId}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwstoreId" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwstoreId">Se requiere usuario</small>
            </div>

            <div class="field p-text-bold">
                <label for="opt">{{lbl_type}} {{lbl_vendor}}</label>
                <input type="text" pInputText id="name" [(ngModel)]="vwsuppType" required autofocus />
                <small class="p-error" *ngIf="submitted && !vwsuppType">Se requiere nombre</small>
            </div>

            <!--
            <div class="field p-text-bold">
            <label for="opt">Celular</label>
            <p-inputNumber [(ngModel)]="dataView.mobPhon" mode="decimal" inputId="withoutgrouping" [useGrouping]="false"> </p-inputNumber></div> 
             
            <div class="field p-text-bold">
            <label for="opt" *ngIf='!showGuides && !showSuppliers'>{{this.lbl_email}} </label>
            <input type="text" *ngIf='!showGuides && !showSuppliers' pInputText id="name" [(ngModel)]="dataView.email1" required autofocus maxlength="50" /></div>  
             -->

        </ng-template>

        <ng-template pTemplate="footer">
            <button pButton pRipple label="{{this.lbl_back}}" icon="pi pi-times" class="p-button-text"
                (click)="hideDialog()"></button>
            <button pButton pRipple label="{{this.lbl_save}}" icon="pi pi-check" class="p-button-text"
                (click)="createSupplier()"></button>
        </ng-template>
    </p-dialog>

</p-fieldset>